import { createRouter, createWebHistory,createWebHashHistory } from 'vue-router';
//import Home from '../components/HelloWorld.vue';
import index from '../components/index/index.vue';
import LoginIndex from '../components/login/index.vue';
import user from '../components/user/index.vue';
import search from '../components/search/index.vue';
import product from '../components/product/index.vue';
import RegisterIndex from '../components/register/index.vue';
import forgetPassword from '../components/register/forget_password.vue';
import agreementUser from '../components/agreement/user.vue';
import agreementPrivacy from '../components/agreement/privacy.vue';
import download from '../components/download.vue';
 
// 路由配置
const routes = [
  { path: '/', component: index },
  { path: '/download', component: download },
  { path: '/login', component: LoginIndex },
  { path: '/user', component: user },
  { path: '/search', component: search },
  { path: '/product', component: product },
  { path: '/register', component: RegisterIndex },
  { path: '/forgetPassword', component: forgetPassword },
  { path: '/agreementUser', component: agreementUser },
  { path: '/agreementPrivacy', component: agreementPrivacy },
];
// 创建router实例
const router = createRouter({
  history: createWebHashHistory(),
  routes,
});
 
export default router;
